import { type Config, getPublicClient } from "@wagmi/core";
import { config } from "@/../config/wagmi.config";

export default function useViemPublicClient() {
  return getPublicClient(config as Config);
}
